import React, { Fragment, useContext, useEffect, useRef, useState } from 'react'
import { Alert } from 'react-bootstrap';

import { UserContext } from "../../Contexts/UserContext/UserContext.js";
import { Row } from "../../components/Row";
import { Spaces } from "../../components/Spaces";
import { TextDisplay } from "../../components/TextDisplay/TextDisplay";
import { Loader } from "../../components/Loader";
import Bold from '../../components/Bold.js';
import { default_func_jsx_fail, FaAlertIcon, FaInfoCircle } from '../../helpers/helpers.js';
import useLog from '../../hooks/useLog.js';
import { confirmPopupHard } from '../../components/confirmPopup.js';
import useTxSender from '../../hooks/useTxSender.js';
import SuccessTxSender from '../../components/SuccessTxSender.js';
import InputTokenAddress from '../../components/InputTokenAddress.js';




export default function Slide_TokkenR_SendRevoke(props) {
	const userContext = useContext(UserContext)
	const log = useLog("Slide_TokkenR_SendRevoke: ")

	// --- VARS ---

	const coinprops = userContext.get_selected_coin_props()
	const tokenID = coinprops.tokenid
	const tokenName = coinprops.name

	const tokenActionID = tokenID + "_sendRevoke"
	const mess_default = "" //"Un récapitulatif des "+tokenName+" à minter va s'afficher ici"

	// state & refs
	const ref_messageEndRef = useRef(null) // for autoscroll
	const [revoker_sendTo, set_revoker_sendTo] = useState("")
	// const [revoker_origin, set_revoker_origin] = useState(null)

	/**
	 *  TODO how to ensure it should be synced ?
	 * also issue that if we sync() it in UserContext, and even if we setState() it after that,
	 * it will not auto-re-render components, because the ref doesn't change
	 * */
	const revokerJig = userContext.revokerJig
	const revoker_origin = revokerJig ? revokerJig.origin : null
	const revoker_owner = revokerJig ? revokerJig.owner : null
	const wallet_owner = userContext.address_owner
	const isRevokerOwner = revoker_owner === wallet_owner

	const array_bool_user_inputs = [
		Boolean(revoker_sendTo && revoker_sendTo.length > 0),
		Boolean(revoker_origin && revoker_origin.length > 0),
	]

	const token_balance = userContext.tokens_balance[tokenID]
	const bool_context_has_loaded = (token_balance != null && revoker_origin != null) // && (context.bsvprice !=null)

	// --- FUNCTIONS ---

	// // do only once
	// useEffect(()=>{
	// 	const fetchData = async () => {
	// 		log("fetchData : start")
	// 		const revoker_origin = (await context.get_revokerjig()).origin
	// 		log("fetchData : revoker_origin=",revoker_origin)
	// 		set_revoker_origin(revoker_origin)
	// 	}
	// 	log("calling fetchData()")
	// 	fetchData()
	// }, [])

	async function func_empty_fields() {
		set_revoker_sendTo("")
	}

	var jsx_loading = null //<LoaderWithMess mess={mess_default} />
	var jsx_recap = null // add one by one
	if (revoker_origin && revoker_origin.length > 0) {
		jsx_recap = <Fragment>
			{jsx_recap}Contrat de revoke: {revoker_origin} <br />
			<br />
			Propriétaire actuel: {revoker_owner}<br />
			{wallet_owner && wallet_owner == revoker_owner ?
				"Vous êtes le propriétaire actuel."
				:
				"Vous n'êtes pas le propriétaire actuel."
			}
		</Fragment>
	} else {
		jsx_recap = <Fragment>
			{jsx_recap}Chargement du contrat en cours... <br />
		</Fragment>
	}
	if (revoker_sendTo && revoker_sendTo.length > 0) {
		jsx_recap = <Fragment>
			{jsx_recap} <br /><br />Envoyer à {revoker_sendTo} <br />
		</Fragment>
	}

	const jsx_sending = <Fragment>
		Envoi du contrat de Revoke en cours... &nbsp;
		<i className="reloadIcon fas fa-sync fa-spin" />
	</Fragment>

	const func_jsx_success = (txstate) => {
		return (
			<SuccessTxSender txstate={txstate}>
				Envoi du contrat de Revoke avec succès vers {txstate.sendTo}<br />
			</SuccessTxSender>
		)
	}

	// --- HOOK useTxSender ---

	const [
		bool_broadcast_lock,
		func_resetMess,
		dict_sendbutton_style,
		jsx_mess,
	]
		= useTxSender(
			tokenActionID,
			array_bool_user_inputs,
			bool_context_has_loaded,
			ref_messageEndRef,
			mess_default,
			jsx_loading,
			jsx_recap,
			jsx_sending,
			func_jsx_success,
			default_func_jsx_fail,
			func_empty_fields,
		)

	// --- FUNCTIONS ---

	function handleChange_revoker_sendTo(new_val) {
		if (bool_broadcast_lock) return // don't allow edit during sending
		func_resetMess()

		// var val = event.target.value
		new_val = new_val.toString()

		log("new revoker_sendTo=", new_val)
		set_revoker_sendTo(new_val)
	}

	const handleClick = async (event) => {
		event.preventDefault() // prevent redirection
		// don't allow parallel sends
		if (bool_broadcast_lock) {
			window.alert("Echec: une demande est déjà en cours d'envoi.")
			return
		}

		const confirm_message = "⚠️ ETES VOUS CERTAIN DE VOULOIR ENVOYER LE CONTRAT DE REVOKE ? ⚠️"
		const confirmed = await confirmPopupHard(confirm_message)
		if (!confirmed) return // abort

		var _revoker_sendTo = revoker_sendTo.split(":")[1] // remove prefix

		log("handleClick(): _revoker_sendTo=", _revoker_sendTo)

		// async but we don't want to await here !
		userContext.send_revokerContract(_revoker_sendTo)
	}

	// --- DISPLAY ---

	log("\n revoker_sendTo=", revoker_sendTo,
		"\n revoker_origin=", revoker_origin,
		"\n bool_broadcast_lock=", bool_broadcast_lock,
		"\n bool_context_has_loaded=", bool_context_has_loaded,)

	return (
		<div>
			<h1><i className="fas fa-paper-plane" /><Spaces count="3" />
				Envoyer le contrat de revoke
			</h1>
			<br />

			{isRevokerOwner ? null : <>
				<Alert variant="danger">
					<Bold>Vous ne semblez pas être l'administrateur de ce token.</Bold>
				</Alert><br />
			</>}

			<Alert variant="light">
				<FaInfoCircle />
				Le contrat de revoke permet de Backup, Freeze, et Revoke.
				Pour une sécurité optimale, envoyer le sur un portefeuille
				que vous gardez offline et qui ne servira qu'en dernier recours.
			</Alert>

			<Alert variant="danger">
				<Bold>
					<FaAlertIcon />
					Assurez vous d'avoir plusieurs sauvegardes offline de la phrase clé secrète du
					portefeuille contenant le contrat de revoke.
					En cas de perte il n'y a aucune action possible.
					Il s'agit de la clé la plus importante (backup key).
				</Bold>
			</Alert>
			<br />

			<InputTokenAddress
				tokenName={tokenName}
				tokenID={tokenID}
				variant="token"
				value={revoker_sendTo}
				onValidChange={handleChange_revoker_sendTo}
				title={"A quelle adresse " + tokenName + " voulez-vous envoyer le contrat de revoke ?"}
			/>

			<center>
				<div ref={ref_messageEndRef}>
					{jsx_mess ?
						<Row><TextDisplay>
							{jsx_mess}
						</TextDisplay></Row>
						: null}
				</div>
			</center>

			<Row>
				<button onClick={handleClick} style={dict_sendbutton_style} className="submitbutton" >
					Envoyer Contrat de Revoke
				</button>
			</Row>

		</div>
	)
}
